// The charset a promo code may use, mirroring `modules/promos.has_visible_charset`
// character for character: a code is something a buyer TYPES and a practitioner READS, so
// it is letters (any script), digits, "-" and "_", plus combining marks (Mn, Mc: Thai vowel
// signs, Devanagari matras, accents) that directly follow a letter, digit or another mark.
// Format characters (zero-width space, ZWJ, BOM, soft hyphen), whitespace and other
// punctuation have no glyph or get mangled by a checkout form, so they are refused.

const BASE = /^[\p{L}\p{N}]$/u;
const MARK = /^[\p{Mn}\p{Mc}]$/u;

/** The server's `normalize_code`: strip, upper-case, then compose (NFC), in that order. */
export const normalizePromoCode = (code) => (code || "").trim().toUpperCase().normalize("NFC");

/** True when `code`, once normalised, only uses characters a client may choose. */
export function isChoosablePromoCode(code) {
  const normalised = normalizePromoCode(code);
  if (!normalised) return false;
  let carriesMarks = false;     // the previous character can carry a mark
  for (const ch of normalised) {
    if (BASE.test(ch)) carriesMarks = true;
    else if (ch === "-" || ch === "_") carriesMarks = false;
    else if (MARK.test(ch) && carriesMarks) continue;
    else return false;
  }
  return true;
}

/** The first item of a FastAPI 422 body array that refuses the `code` field's VALUE
 *  (a validator's `value_error`; length rules have their own types). */
export const refusesCodeCharset = (error) => {
  const detail = error?.response?.data?.detail;
  return Array.isArray(detail) && detail.some(
    (item) => item?.type === "value_error" && Array.isArray(item.loc)
      && item.loc[item.loc.length - 1] === "code");
};
